import type { FaireProductEntity } from "../../entity_types/product";

export const p_dbansnjogh: FaireProductEntity = {
  token: "p_dbansnjogh",
  type: "product",
  name: "Owl Plug-In Wax Warmer Gift Set",
  brandName: "A Cheerful Giver",
  imageUrl:
    "https://cdn.faire.com/fastly/6eea3e96918ee9aaa2c7e773b8fac86abce9ef09c325f838b37f9e534090eac9.jpeg",
  priceDollars: 12,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/01445ab68cd1e9a4c43add01029bc847f5348fd895c09179ee6120ce113642bd.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
